import React, {useContext, useState, useEffect} from 'react'
import SideBar from '../../../Components/Nav/SideBar';
import s from '../styles/StudentProfile.module.scss'
import {SessionContext} from 'Utils/sessions'
import {Root} from 'Root'
import {
    EditAboutMe, EditTestScores, EditAccomplishments, EditCareerHistory, EditSkills, EditInterests,
    UploadResume, EditFeatured
} from './Components/EditAboutMeMentor'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import {RiArrowGoBackLine} from "react-icons/ri";

const ReturnToProfileButton = <>
    <button className={s.returnToProfileButton} onClick={() => {
        const location = window.location.href;
        window.location.href = location.replace('/edit', '')
    }}>
        <RiArrowGoBackLine/> Return to profile
    </button>
</>

const EditProfileMentor = () => {
    const {session, refreshSession} = useContext(SessionContext)
    const [profile, setProfile] = useState({});

    if (!session?.jwt) {
        window.location.href = "/login"
    }

    useEffect(() => {
        Root.userApi.getUserProfile(session.jwt).then((res) => {
            if (res.status === 200) {
                setProfile(res.data)
            }
        }).catch(() => {
            setProfile({})
        })
    }, [session])

    return <div className={s.mentorEditProfile}>
        <SideBar title={"Edit Profile"} session={session} leftNav={ReturnToProfileButton}>
            <div className={s.editProfileGrid}>
                <div className={s.col}>
                    <div>
                        <h3 className='heading'><strong>Basic Information</strong></h3>
                        <EditAboutMe session={session} profile={profile} refreshSession={refreshSession}/>
                    </div>
                    <div className='mt-4'>
                        <h3 className='heading'><strong>Resume</strong></h3>
                        <UploadResume session={session} profile={profile} refreshSession={refreshSession}/>
                    </div>
                    <div className='mt-4'>
                        <h3 className='heading'><strong>GPA</strong></h3>
                        <EditTestScores session={session} profile={profile} refreshSession={refreshSession}/>
                    </div>
                </div>
                <div className={s.col}>
                    <div>
                        <h3 className='heading'><strong>NXSTEP Matching Profile</strong>
                            <span className='text-muted fs-13 ms-2' style={{fontWeight: 'normal'}}>We use this to find students most like you</span>
                        </h3>
                        <Card className='xlCard'>
                            <Card.Body>
                                <Button className='ps-0 btnLink wide' href='/onboarding?prev=ep'
                                        style={{fontSize: '14px'}}>{profile.profileComplete ? 'Update' : 'Complete'}</Button>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className='mt-4'>
                        <h3 className='heading'><strong>Career History</strong></h3>
                        <EditCareerHistory type='job_positions' session={session}/>
                    </div>
                    <div className='mt-4'>
                        <h3 className='heading'><strong>Extracurriculars</strong></h3>
                        <EditCareerHistory type='experiences' session={session}/>
                    </div>
                    <div className='mt-5'>
                        <h3 className='heading'><strong>Accomplishments</strong></h3>
                        <EditAccomplishments session={session}/>
                    </div>
                    <div className='mt-5'>
                        <h3 className='heading'><strong>Skills</strong></h3>
                        <EditSkills session={session}/>
                    </div>
                    <div className='mt-5'>
                        <h3 className='heading'><strong>Interests</strong></h3>
                        <EditInterests session={session}/>
                    </div>
                    <div className='mt-5'>
                        <h3 className='heading'><strong>Featured Work</strong></h3>
                        <EditFeatured session={session}/>
                    </div>
                </div>
            </div>
        </SideBar>
    </div>
}

export default (EditProfileMentor);
